import { AxiosResponse } from "axios"
import SecureClient from "../SecureClient"

export class BlobsClient extends SecureClient {
	private _urlBase: string

	constructor() {
		super()
		this._urlBase = 'Blobs'
	}

	public getBlob(blobId: string): Promise<AxiosResponse<Blob>> {
		return this._api.get<Blob>(`Blobs/${blobId}`, {
			headers: {
				...this.acceptHeader(),
				// ...this.contentTypeHeader()
			},
			responseType: 'blob'
		})
	}
}
